module.exports = __webpack_public_path__ + "img/certificering_header.b5669b30.webp";